import type { SearchHit } from '@contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { setDeviceName } from '../lib/api';
import { useScope } from '../scope/scope';
import { Button } from '../ui/Button';

export function DeviceName({ device }: { device: SearchHit }) {
  const { mspId, memberships } = useScope();
  const client = useQueryClient();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(device.displayName ?? '');
  const save = useMutation({ mutationFn: (displayName: string | null) => setDeviceName(mspId, device.id, displayName),
    onSuccess: async () => {
      setEditing(false);
      await client.invalidateQueries({ queryKey: ['scope', mspId] });
    } });
  if (!memberships.some(m => m.role === 'owner' && !m.organizationId && !m.siteId)) return null;
  if (!editing) return <Button variant="ghost" size="sm" onClick={() => { setName(device.displayName ?? ''); save.reset(); setEditing(true); }}>
    {device.displayName ? 'Edit friendly name' : 'Add friendly name'}
  </Button>;
  return <form className="flex flex-wrap items-center gap-2" onSubmit={e => { e.preventDefault(); save.mutate(name.trim() || null); }}>
    <label className="text-sm" htmlFor="device-friendly-name">Friendly name</label>
    <input id="device-friendly-name" aria-describedby="device-name-audience" autoFocus value={name} maxLength={120} disabled={save.isPending}
      onChange={e => setName(e.target.value)} className="rounded-md border border-line bg-raised px-3 py-2 text-sm" />
    <p id="device-name-audience" className="w-full text-sm text-ink-3">Shown to this customer’s users in the portal and tray.</p>
    <Button type="submit" size="sm" disabled={save.isPending}>Save</Button>
    {device.displayName && <Button size="sm" variant="ghost" disabled={save.isPending} onClick={() => save.mutate(null)}>Clear name</Button>}
    <Button size="sm" variant="ghost" disabled={save.isPending} onClick={() => setEditing(false)}>Cancel</Button>
    {save.isError && <p role="alert" className="w-full text-sm text-attention">The name couldn’t be saved. Check your access and try again.</p>}
  </form>;
}
